import { AsyncPipe, NgClass } from '@angular/common';
import { Component, computed, input } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { TranslatePipe } from '@core/pipes';
import { ButtonComponent, MiniProfileComponent, SvgComponent } from '@shared/components';
import { CmsImagePipe, CmsService } from '@selfcare/cms';
import { toSignal } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';
import { userFeature } from '@src/state';
import { getLinkNavigationList } from '@core/const/const';
import { AppRouting } from '@core/enums';
import { generalFeature } from '@src/state/general';
import { ProductType } from '@core/contracts/data-contracts';

@Component({
  selector: 'sc-desktop-header',
  imports: [
    RouterLink,
    RouterLinkActive,
    TranslatePipe,
    AsyncPipe,
    SvgComponent,
    MiniProfileComponent,
    CmsImagePipe,
    CmsImagePipe,
    ButtonComponent,
    NgClass
  ],
  templateUrl: './desktop-header.component.html',
})
export class DesktopHeaderComponent {
  public logoUrl = toSignal(this.cmsService.headerLogo$);
  public isLimited = this.store.selectSignal(userFeature.selectIsMsisdnLimited);
  public currentUser = this.store.selectSignal(userFeature.selectCurrent);
  public isJottaInUse = this.store.selectSignal(userFeature.selectIsJottaInUse);
  public isTerminated = this.store.selectSignal(userFeature.selectIsTerminated);
  public isDataOnly = this.store.selectSignal(generalFeature.selectIsDataOnly);
  public isB2B = this.store.selectSignal(userFeature.selectIsB2B);
  public isPortingBlocked = this.store.selectSignal(userFeature.selectIsPortingBlocked);
  public activeProduct = this.store.selectSignal(userFeature.selectActiveProduct);

  public isInternet = computed(() => this.activeProduct() === ProductType.Internet);

  public hideNav = input<boolean>(false);

  public links = computed(() => {
    return getLinkNavigationList(
      this.isLimited(),
      this.isTerminated(),
      this.isJottaInUse(),
      this.isDataOnly(),
      this.isB2B(),
      this.isInternet()
    ).filter((link) => link.icon);
  });

  constructor(
    private readonly cmsService: CmsService,
    private readonly store: Store,
    private readonly router: Router
  ) { }

  handleLogoRedirect() {
    this.currentUser
      ? this.router.navigate([AppRouting.Overview])
      : this.router.navigate([AppRouting.Login]);
  }
}
